import http from '@amit/composables/src/useHttp';
import { useApi } from '@amit/composables';

export const checkIframeEmbed = (url: string) => {
  return useApi(http.post(`courses/iframe?url=${url}`));
};
